import React, { useEffect } from 'react';
import '../cs/temp.css';
import '../cs/te.css';
import AOS from "aos";
import "aos/dist/aos.css";

function AiMlDevelopment() {
  useEffect(() => {
    AOS.init({ duratio: 1000, once: true });
  }, [])
  return (
    <div className="webdev-page" style={{ overflowX: "hidden" }}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content" >
              <h1 className="inner-title">AI & ML Development</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section ai-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header text-left">
              <h2 data-aos="fade-up">Intelligent Solutions for Tomorrow's Challenges</h2>
              <p className="intro-text">
                At Codenix Infotech, we specialize in AI and Machine Learning solutions that transform businesses by automating workflows, uncovering valuable insights, and driving smarter decision-making. Our team of AI engineers and data scientists designs customized solutions to solve complex problems and fuel innovation.
              </p>
            </div>

          </div>
          <div className="intro-image ai-graphic">
            <div className="neural-network">
              <div className="node n1"></div>
              <div className="node n2"></div>
              <div className="node n3"></div>
              <div className="node n4"></div>
              <div className="node n5"></div>
              <div className="node n6"></div>
              <div className="node n7"></div>
              <div className="node n8"></div>
              <div className="node n9"></div>
              <div className="connection c1"></div>
              <div className="connection c2"></div>
              <div className="connection c3"></div>
              <div className="connection c4"></div>
              <div className="connection c5"></div>
              <div className="connection c6"></div>
              <div className="connection c7"></div>
              <div className="connection c8"></div>
              <div className="connection c9"></div>
              <div className="connection c10"></div>
              <div className="connection c11"></div>
              <div className="connection c12"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="webdev-services-section ai-services">
        <div className="container">
          <div className="section-header">
            <h2>Our AI & ML Services</h2>
            <p className="section-description">
              Comprehensive AI and machine learning solutions to drive innovation and efficiency
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="100">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>AI Automation</h3>
              <p>Streamline operations and eliminate repetitive tasks with powerful AI-driven automation tailored to your business needs.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>Machine Learning Models</h3>
              <p>Design and implement advanced ML models to analyze data, forecast trends, and optimize decision-making.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-chart-pie"></i>
              </div>
              <h3>Data Insights</h3>
              <p>Leverage AI to unlock hidden patterns in data, helping you understand customers and market trends better.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-robot"></i>
              </div>
              <h3>Computer Vision</h3>
              <p>Build AI-powered systems that can analyze images and videos, detect objects, and interpret visual data.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-language"></i>
              </div>
              <h3>Natural Language Processing</h3>
              <p>Develop intelligent systems capable of understanding, interpreting, and generating human language.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Predictive Analytics</h3>
              <p>Forecast business outcomes with accuracy using advanced predictive models built on historical data.</p>
            </div>
          </div>
        </div>
      </section>



      {/* Development Process Section */}
      <section className="design-process-section ai-process">
        <div className="container">
          <div className="section-header">
            <h2>Our AI & ML Development Process</h2>
            <p className="section-description">
              A structured approach to delivering intelligent and efficient AI and ML solutions for your business
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "Requirement Analysis",
                text: "Collaborate to define clear goals, use cases, and success metrics for your AI solution.                "
              },
              {
                num: 2,
                title: "Data Collection & Preparation",
                text: "Gather, clean, and preprocess your data for optimal AI and ML model performance.                "
              },
              {
                num: 3,
                title: "Model Development",
                text: "Design, train, and fine-tune models tailored to your unique business challenges."
              },
              {
                num: 4,
                title: "Testing & Validation",
                text: "Run extensive tests to ensure accuracy, scalability, and performance of AI models.                "
              },
              {
                num: 5,
                title: "Integration",
                text: "Seamlessly embed AI capabilities into your existing workflows and systems.                "
              },
              {
                num: 6,
                title: "Support & Optimization",
                text: "Provide ongoing Optimization, monitoring, and training to ensure your AI evolves with your business.  "
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AI Applications Section */}
      <section className="ai-applications-section d-none">
        <div className="container">
          <div className="section-header">
            <h2>AI & ML Applications</h2>
            <p className="section-description">
              Discover how our AI and ML solutions can transform different aspects of your business
            </p>
          </div>

          <div className="use-cases-grid">
            <div className="use-case-card">
              <div className="use-case-icon">
                <i className="fas fa-user-tie"></i>
              </div>
              <div className="application-content">
                <h3>Customer Experience</h3>
                <p>Intelligent chatbots, personalized recommendations, and sentiment analysis</p>
              </div>
            </div>

            <div className="use-case-card ">
              <div className="use-case-icon">
                <i className="fas fa-industry"></i>
              </div>
              <div className="application-content">
                <h3>Manufacturing</h3>
                <p>Predictive maintenance, quality control, and supply chain optimization</p>
              </div>
            </div>

            <div className="use-case-card ">
              <div className="use-case-icon">
                <i className="fas fa-heartbeat"></i>
              </div>
              <div className="application-content">
                <h3>Healthcare</h3>
                <p>Disease prediction, medical imaging analysis, and treatment optimization</p>
              </div>
            </div>

            <div className="use-case-card ">
              <div className="use-case-icon">
                <i className="fas fa-shopping-cart"></i>
              </div>
              <div className="application-content">
                <h3>Retail</h3>
                <p>Inventory management, demand forecasting, and personalized marketing</p>
              </div>
            </div>

            <div className="use-case-card ">
              <div className="use-case-icon">
                <i className="fas fa-money-bill-wave"></i>
              </div>
              <div className="application-content">
                <h3>Finance</h3>
                <p>Fraud detection, risk assessment, and algorithmic trading</p>
              </div>
            </div>

            <div className="use-case-card ">
              <div className="use-case-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <div className="application-content">
                <h3>Security</h3>
                <p>Anomaly detection, facial recognition, and threat intelligence</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="design-principles-section ai-features">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our AI & ML Solutions</h2>
            <p className="section-description">
              What makes our AI and machine learning solutions stand out
            </p>
          </div>

          <div className="services-grid">
            {[
              {
                icon: "fas fa-puzzle-piece",
                title: "Customized Solutions",
                text: "Tailor-made AI and ML solutions to fit your business goals."
              },
              {
                icon: "fas fa-bolt",
                title: "Real-Time Results",
                text: " Instant analytics and automation for better decision-making."
              },
              {
                icon: "fas fa-plug",
                title: "Seamless Integration",
                text: "Smooth implementation with your existing infrastructure."
              },
              {
                icon: "fas fa-piggy-bank",
                title: "Cost Efficiency",
                text: "Automate processes to save time and reduce operational costs"
              },
              {
                icon: "fas fa-lightbulb",
                title: "Smart Insights",
                text: "Use AI-driven analytics for smarter, data-backed strategies"
              },
              {
                icon: "fas fa-hands-helping",
                title: "Ongoing Support",
                text: " Training, updates, and expert support to keep you ahead."
              }
            ].map((feature, idx) => (
              <div className="service-card" key={idx} data-aos="fade-up-left" data-aos-delay="200">
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="cta-section mt-5 ai-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Harness the Power of AI & ML?</h2>
            <p>Let's create intelligent solutions that drive innovation and efficiency for your business.</p>
            <a href="/contact" className="cta-button">Get a Free AI Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AiMlDevelopment;
